import React from 'react';
import { ListItem } from '@/components/Ui';
import { MenuDropdown } from '@/components/Common';
import { QuestionOutput } from '@/api/gql/graphql';
import { MenuItem } from 'primereact/menuitem';

type ListWithSubItemsProps = {
  items: QuestionOutput[];
  selectedItem: QuestionOutput | null;
  onItemSelect: (item: QuestionOutput) => void;
  menuItems: MenuItem[];
  leftBorderColor?: string;
  dotsStyle?: string;
  listItemStyle?: string;
};

const ListWithSubItems: React.FC<ListWithSubItemsProps> = ({
  items,
  selectedItem,
  onItemSelect,
  menuItems,
  leftBorderColor = '#FEC200',
  dotsStyle = 'hover:bg-[#FEC20033]',
  listItemStyle = '!bg-black',
}) => {
  return (
    <div className="flex flex-col">
      {items?.map((item) => (
        <div key={item._id}>
          <ListItem
            connector
            listItemStyle={listItemStyle}
            leftBorderColor={leftBorderColor}
            connectorStyle="before:h-[calc(100%_-_20px)]"
            focused={item === selectedItem}
            subItems={item.responses
              .filter((res) => res.response !== '')
              .map((res) => ({
                connector: true,
                children: (
                  <div>
                    <p className="text-white text-[10px]">{res.response}</p>
                  </div>
                ),
                leftBorderColor: res.isRight ? '#2ecc71' : '#EA242C',
              }))}
          >
            <div className="flex justify-between">
              <div className="flex flex-col">
                <p>{item.name}</p>
                <p className="text-[9.75px] font-normal leading-3 text-left text-[#939393] pt-1">
                  Type {item.type}
                </p>
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  onItemSelect(item);
                }}
              >
                <MenuDropdown menuItems={menuItems} dotsStyle={dotsStyle} />
              </div>
            </div>
          </ListItem>
        </div>
      ))}
    </div>
  );
};

export default ListWithSubItems;
